import { combineReducers } from 'redux'

//reducers
import authReducer from './auth'

export default combineReducers({
    authReducer
})
